(function () {
  const floatCTA = document.getElementById('floatCTA');
  if (floatCTA) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) {
        floatCTA.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-6', 'scale-90');
        floatCTA.classList.add('opacity-100', 'translate-y-0', 'scale-100');
      } else {
        floatCTA.classList.add('opacity-0', 'pointer-events-none', 'translate-y-6', 'scale-90');
        floatCTA.classList.remove('opacity-100', 'translate-y-0', 'scale-100');
      }
    });
  }
})();
(function () {
  const track = document.getElementById('sliderTrack');
  if (!track) return;
  const sliderImages = track.querySelectorAll('.slider-img');
  const dots = document.querySelectorAll('.gallery-dot');
  const totalSlides = sliderImages.length;
  let slideIdx = 0;

  function updateSlider() {
    track.style.transform = 'translateX(-' + (slideIdx * 100) + '%)';
    dots.forEach((d, i) => d.classList.toggle('active', i === slideIdx));
  }
  window.slideMove = function (dir) {
    slideIdx = (slideIdx + dir + totalSlides) % totalSlides;
    updateSlider();
  };
  window.slideTo = function (idx) {
    slideIdx = idx;
    updateSlider();
  };
  let touchStartX = 0;
  track.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
  }, {
    passive: true
  });
  track.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) window.slideMove(diff > 0 ? 1 : -1);
  }, {
    passive: true
  });
})();
(function () {
  const lightbox = document.getElementById('lightbox');
  const lbImg = document.getElementById('lbImg');
  const lbContent = document.getElementById('lbContent');
  const lbCounter = document.getElementById('lbCounter');
  const lbDotsContainer = document.getElementById('lbDots');
  if (!lightbox || !lbImg || !lbContent) return;
  const images = Array.from(document.querySelectorAll('.slider-img')).map(img => img.src);
  let lbIdx = 0;
  let lbTouchStartX = 0;
  let lbTouchStartY = 0;
  let lbTouchMoveX = 0;
  let lbIsSwiping = false;

  function renderLbDots() {
    if (!lbDotsContainer) return;
    lbDotsContainer.innerHTML = images.map((_, i) => '<div class="lb-dot ' + (i === lbIdx ? 'active' : '') + '" onclick="lbTo(' + i + ')"></div>').join('');
  }

  function updateLb() {
    lbImg.src = images[lbIdx];
    if (lbCounter) lbCounter.textContent = (lbIdx + 1) + ' / ' + images.length;
    renderLbDots();
  }
  window.openLightbox = function (idx) {
    lbIdx = idx;
    updateLb();
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeLightbox = function (e) {
    if (e && e.target !== lightbox && e.target.closest('.lightbox-close') === null) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.lbMove = function (dir) {
    lbIdx = (lbIdx + dir + images.length) % images.length;
    updateLb();
  };
  window.lbTo = function (idx) {
    lbIdx = idx;
    updateLb();
  };
  lbContent.addEventListener('touchstart', e => {
    lbTouchStartX = e.touches[0].clientX;
    lbTouchStartY = e.touches[0].clientY;
    lbTouchMoveX = 0;
    lbIsSwiping = false;
    lbImg.classList.add('swiping');
  }, {
    passive: true
  });
  lbContent.addEventListener('touchmove', e => {
    const diffX = e.touches[0].clientX - lbTouchStartX;
    const diffY = e.touches[0].clientY - lbTouchStartY;
    if (!lbIsSwiping && Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) lbIsSwiping = true;
    if (lbIsSwiping) {
      lbTouchMoveX = diffX;
      lbImg.style.transform = 'translateX(' + (diffX * 0.4) + 'px)';
    }
  }, {
    passive: true
  });
  lbContent.addEventListener('touchend', () => {
    lbImg.classList.remove('swiping');
    lbImg.style.transform = '';
    if (lbIsSwiping) {
      if (lbTouchMoveX > 60) window.lbMove(-1);
      else if (lbTouchMoveX < -60) window.lbMove(1);
    }
    lbIsSwiping = false;
    lbTouchMoveX = 0;
  }, {
    passive: true
  });
  document.addEventListener('keydown', e => {
    if (!lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') window.closeLightbox();
    if (e.key === 'ArrowLeft') window.lbMove(-1);
    if (e.key === 'ArrowRight') window.lbMove(1);
  });
})();
(function () {
  const reviewSlider = document.getElementById('reviewSlider');
  const rsImg = document.getElementById('rsImg');
  const rsUser = document.getElementById('rsUser');
  const rsStars = document.getElementById('rsStars');
  const rsCounter = document.getElementById('rsCounter');
  const rsImgWrap = document.getElementById('rsImgWrap');
  const reviewImgs = Array.from(document.querySelectorAll('.review-img-wrap'));
  if (!reviewSlider || !rsImg || !reviewImgs.length) return;
  let rsIdx = 0;
  let rsTouchStartX = 0;
  let rsTouchMoveX = 0;
  let rsIsSwiping = false;

  function updateReviewSlider() {
    const item = reviewImgs[rsIdx];
    rsImg.src = item.querySelector('img').src;
    if (rsUser) rsUser.textContent = item.dataset.user || '';
    const rating = parseInt(item.dataset.rating, 10) || 5;
    if (rsStars) {
      let starsHTML = '';
      for (let i = 0; i < 5; i++) {
        starsHTML += i < rating ? '<i class="fas fa-star"></i>' : '<i class="fa-regular fa-star"></i>';
      }
      rsStars.innerHTML = starsHTML;
    }
    if (rsCounter) rsCounter.textContent = (rsIdx + 1) + ' / ' + reviewImgs.length;
  }
  window.openReviewSlider = function (idx) {
    rsIdx = idx;
    updateReviewSlider();
    reviewSlider.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeReviewSlider = function (e) {
    if (e && e.target !== reviewSlider && !e.target.closest('[onclick*="closeReviewSlider"]')) return;
    reviewSlider.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.rsMove = function (dir) {
    rsIdx = (rsIdx + dir + reviewImgs.length) % reviewImgs.length;
    updateReviewSlider();
  };
  if (rsImgWrap) {
    rsImgWrap.addEventListener('touchstart', e => {
      rsTouchStartX = e.touches[0].clientX;
      rsTouchMoveX = 0;
      rsIsSwiping = false;
      rsImg.classList.add('swiping');
    }, {
      passive: true
    });
    rsImgWrap.addEventListener('touchmove', e => {
      const diffX = e.touches[0].clientX - rsTouchStartX;
      if (Math.abs(diffX) > 10) {
        rsIsSwiping = true;
        rsTouchMoveX = diffX;
        rsImg.style.transform = 'translateX(' + (diffX * 0.4) + 'px)';
      }
    }, {
      passive: true
    });
    rsImgWrap.addEventListener('touchend', () => {
      rsImg.classList.remove('swiping');
      rsImg.style.transform = '';
      if (rsIsSwiping) {
        if (rsTouchMoveX > 60) window.rsMove(-1);
        else if (rsTouchMoveX < -60) window.rsMove(1);
      }
      rsIsSwiping = false;
    }, {
      passive: true
    });
  }
  document.addEventListener('keydown', e => {
    if (!reviewSlider.classList.contains('open')) return;
    if (e.key === 'Escape') window.closeReviewSlider();
    if (e.key === 'ArrowLeft') window.rsMove(-1);
    if (e.key === 'ArrowRight') window.rsMove(1);
  });
})();

function toggleFaq(btn) {
  const item = btn.parentElement;
  const wasActive = item.classList.contains('active');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
  if (!wasActive) item.classList.add('active');
}
